<template>
  <div class="container_presentation" v-if="course.name">
    <div class="spacer"></div>
    <div class="spacer"></div>
    <b-container>
      <b-row>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/logo_rectangle_sm.png" alt="Logo challenge maritima" />
        </b-col>
        <b-col md="6">
          <h2 style="font-weight: bold">{{ course.name }} - {{ course.distance }}</h2>
          <h4>{{ course.date }}</h4>
        </b-col>
        <b-col md="3" class="side_logo_container">
          <img class="side_logo" src="@/assets/img/Logo_TotalEnergies.png" alt="Logo Total energies" />
        </b-col>
      </b-row>
      <b-row>
        <b-col offset-md="3" md="6">
          <div class="spacer"></div>

          <p>
            Le tracé vous portera sur les superbes massifs de CARRY LE ROUET, tout près de la scintillante Calanque des eaux salées et de la splendide Chapelle de notre Dame du Rouet (500 m du départ). Il vous offrira une vue imprenable à 360° sur le
            Port de Carry le Rouet, sur le phare de Sausset les Pins et de la Couronne ainsi que sur La Rade de Marseille.
          </p>

          <p>
            Une épreuve idéale pour : <br />

            - Les Runneurs (es) qui veulent découvrir le Trail<br />

            - Les athlètes qui sortent d'une saison de Cross Country<br />

            - Les amateurs de Courses Nature<br />

            - Les traileurs confirmés, sur un évènement plus facile ou plus difficile selon le rythme que chacun aura choisie de s'imposer et où il sera possible de courir sur toutes les ascensions
          </p>
          <p>
            Les bâtons ne sont pas autorisés sur cette épreuve.<br />

            Pour des raisons de sécurité, Barrières horaires :<br />

            Tout concurrent(te) au-delà de 10h20 au 5kms (point Ravito & Sécurité du tracé), sera arrêté (e), devra rendre la puce de son dossard, puis sera dirigé(e) par l’organisation sur le 7.3km.<br /><br />

            Parrainée par Odile et Stéphane DIAGANA / Invité d’honneur : Joseph MAHMOUD
          </p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <div class="spacer"></div>
      <b-row>
        <b-col md="2"></b-col>
        <b-col md="4">
          <img src="@/assets/img/courses/Calanquaise 2019-246 2.jpg" alt="" />
        </b-col>
        <b-col md="4">
          <img :src="'https://sportips.fr/challenge-maritima/img/flyer/' + course.url_flyer" alt="" />
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col>
          <p><b>Contact : Sandrine BARNICH Tel 06 99 33 84 08</b></p>
        </b-col>
      </b-row>
      <div class="spacer"></div>
      <b-row>
        <b-col>
          <b-button class="infos_btn" download href="https://sportips.fr/challenge-maritima/uploads/REGLEMENT Calanquaise 2023" target="_blank">Réglement</b-button>
          <b-button class="infos_btn" href="https://www.trail-la-calanquaise.com/" target="_blank">Infos course</b-button>
          <b-button class="infos_btn" href="https://www.trail-la-calanquaise.com/parcours-1" target="_blank">GPX de l'épreuve</b-button>

          <b-button class="infos_btn" href="https://www.kms.fr/v5/public/courses/2600" target="_blank">Inscriptions</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: ["course"],
  created() {},
};
</script>

<style lang="scss" scoped>
</style>